import { type GasPayload } from '@atlaskit/analytics-gas-types';

export type IntentDetectionResponseAttributes = {
	searchSessionId: string;
	modelId: string;
	queryHash: string;
	queryLength: number;
	wordCount: number;
	cohort?: string;
	queryClassification: string | null;
	errorName?: string;
	errorMessage?: string;
	patternType?: string;
};

export const onIntentDetectionResponse = ({
	action,
	attributes,
}: {
	action: 'success' | 'fail';
	attributes: IntentDetectionResponseAttributes;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'track',
	action,
	actionSubject: 'intentDetectionResponse',
	actionSubjectId: 'intentDetection',
	attributes,
});
